module.exports = __webpack_public_path__ + "static/media/[Art_and_Music]2010-11-24.b23e0d84.md";